import { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import { ONE_SECOND } from 'constants'

const getIsTimestampExpired = (timestamp, delta) => {
    return timestamp <= Date.now() + delta
}

export function useIsTimestampExpired(timestamp) {
    const { deltaTime } = useSelector(state => state.client)
    const intervalRef = useRef()

    const [isTimestampExpired, setIsTimestampExpired] = useState(
    getIsTimestampExpired(timestamp, deltaTime)
  )

    useEffect(() => {
        const intervalId = setInterval(
            () => setIsTimestampExpired(getIsTimestampExpired(timestamp, deltaTime)),
            ONE_SECOND
        )
        intervalRef.current = intervalId
        return () => clearInterval(intervalId)
    }, [deltaTime, timestamp])

    useEffect(() => {
        if (isTimestampExpired) clearInterval(intervalRef.current)
    }, [isTimestampExpired])

    return getIsTimestampExpired(timestamp, deltaTime)
}



// WEBPACK FOOTER //
// ./hooks/useIsTimestampExpired.js